<template>
  <div
    id="shipmodal"
    class="modal modal-geq modal-map"
    :class="{ 'is-active': active }"
  >
    <div
      class="modal-background"
      @click.prevent="closeForm"
    />
    <div
      v-if="!mapTypeImage"
      class="modal-card modal-map modal-map-image"
      :style="{ backgroundImage: 'url(' + mapurl + ')' }"
    />

    <ship-image-zoom
      v-if="mapTypeImage"
      :display-close-modal-button="true"
      :display-fullscreen-button="false"
      :image-src="mapurl"
      :image-default-class="imageDefaultClass"
      :image-alt="itinerarymodel?.mapImageAltTag"
    />
  </div>
</template>
<script>
import EventBus from '../../vue-functions/event-bus';
import { closeModal } from '../../modals/closeModal';
import ShipImageZoom from './ship-image-zoom.vue';

export default {
  components: {
    'ship-image-zoom': ShipImageZoom
  },
  props: ['mapurl', 'mapTypeImage', 'itinerarymodel'],
  data() {
    return {
      active: false,
      imageDefaultClass: 'fullimage'
    };
  },
  created: function () {
    EventBus.$on('TOGGLE_SHIP_MODAL', () => {
      document.documentElement.classList.toggle('is-clipped');
      this.show();
    });
    EventBus.$on('close-form-state-active', (newActive) => {
      this.active = newActive;
    });
  },
  mounted() {
    this.closeModal(this.closeForm);
  },
  methods: {
    show() {
      this.active = !this.active;
    },
    closeForm() {
      document.documentElement.classList.remove('is-clipped');
      this.active = false;
    },
    closeModal
  }
};
</script>
